(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["champion-quotes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('champion-quotes')) {
    class ChampionQuotes extends HTMLElement {
      connectedCallback() {
        this.count = parseInt(this.dataset.count, 10) || 0;
        this.index = 0;
        this.panels = Array.from(this.querySelectorAll('[data-slide-index]'));
        this.counter = this.querySelector('[data-counter]');
        this.toggle = this.querySelector('[data-toggle]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion && this.count > 1;
        this.speed = parseInt(this.dataset.speed, 10) || 6000;
        this.userPaused = false;

        if (this.count < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1));

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(-1);
          if (e.key === 'ArrowRight') this.go(1);
        });

        // Swipe on touch devices
        this.addEventListener('touchstart', (e) => { this.touchX = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (this.touchX == null) return;
          const delta = e.changedTouches[0].clientX - this.touchX;
          if (Math.abs(delta) > 50) this.go(delta < 0 ? 1 : -1);
          this.touchX = null;
        });

        if (this.toggle) {
          if (!this.autoplay) this.toggle.hidden = true;
          this.toggle.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.userPaused ? this.stop() : this.start();
          });
        }

        // Pause while someone is hovering or interacting
        this.addEventListener('mouseenter', () => this.stop(true));
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop(true));
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.start();
        });

        // Theme editor: jump to the selected block
        this.onBlockSelect = (e) => {
          if (e.detail.sectionId !== this.dataset.sectionId) return;
          const i = parseInt(e.target.dataset.slideIndex, 10);
          if (!isNaN(i)) {
            this.stop(true);
            this.goTo(i);
          }
        };
        this.onBlockDeselect = (e) => {
          if (e.detail.sectionId === this.dataset.sectionId) this.start();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.start();
      }

      disconnectedCallback() {
        this.stop(true);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      go(step) {
        this.goTo(this.index + step);
        this.restart();
      }

      goTo(i) {
        this.index = (i + this.count) % this.count;
        this.panels.forEach((panel) => {
          const active = parseInt(panel.dataset.slideIndex, 10) === this.index;
          panel.classList.toggle('is-active', active);
          panel.toggleAttribute('inert', !active);
          if (active) {
            panel.removeAttribute('aria-hidden');
          } else {
            panel.setAttribute('aria-hidden', 'true');
          }
        });
        if (this.counter) this.counter.textContent = this.index + 1;
      }

      start() {
        if (!this.autoplay || this.userPaused) {
          this.classList.toggle('is-paused', this.autoplay);
          return;
        }
        clearInterval(this.timer);
        this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
        this.classList.remove('is-paused');
        if (this.toggle) this.toggle.setAttribute('aria-label', 'Pause carousel');
      }

      stop(temporary = false) {
        clearInterval(this.timer);
        this.timer = null;
        if (!temporary) {
          this.classList.add('is-paused');
          if (this.toggle) this.toggle.setAttribute('aria-label', 'Play carousel');
        }
      }

      restart() {
        if (this.timer) this.start();
      }
    }

    customElements.define('champion-quotes', ChampionQuotes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["champions-setup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('champions-setup')) {
    class ChampionsSetup extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.totals = Array.from(this.querySelectorAll('[data-total]'));
        this.addButtons = Array.from(this.querySelectorAll('[data-add-to-cart]'));
        this.status = this.querySelector('[data-status]');
        this.format = this.dataset.moneyFormat || '';
        this.round = this.dataset.round === 'true';
        this.auto = this.dataset.totalMode === 'auto';
        this.pricePrefix = this.dataset.prefix || '';
        this.emptyText = this.dataset.emptyText || '';

        this.cards.forEach((card) => {
          card.querySelector('[data-toggle]:not([disabled])')?.addEventListener('click', () => this.toggle(card));
          const select = card.querySelector('[data-variant-select]');
          if (select) select.addEventListener('change', () => this.onVariantChange(card));
        });

        this.addButtons.forEach((button) => button.addEventListener('click', () => this.addToCart()));

        this.update();
      }

      getVariant(card) {
        const select = card.querySelector('[data-variant-select]');
        if (select) {
          const option = select.options[select.selectedIndex];
          return { id: Number(option.value), price: Number(option.dataset.price) };
        }
        return { id: Number(card.dataset.variantId), price: Number(card.dataset.price) };
      }

      get selectedCards() {
        return this.cards.filter((card) => card.dataset.selected === 'true');
      }

      toggle(card) {
        this.setSelected(card, card.dataset.selected !== 'true');
        this.update();
      }

      setSelected(card, selected) {
        card.dataset.selected = selected;
        card.classList.toggle('is-selected', selected);
        const button = card.querySelector('[data-toggle]');
        if (!button) return;
        button.setAttribute('aria-pressed', selected);
        const label = button.querySelector('[data-toggle-label]');
        if (label) label.textContent = selected ? button.dataset.selectedLabel : button.dataset.addLabel;
      }

      onVariantChange(card) {
        const price = card.querySelector('[data-card-price]');
        if (price) price.textContent = this.formatMoney(this.getVariant(card).price);
        this.update();
      }

      update() {
        const selected = this.selectedCards;

        if (this.auto) {
          const total = selected.reduce((sum, card) => sum + this.getVariant(card).price, 0);
          const text = selected.length
            ? (this.pricePrefix ? this.pricePrefix + ' ' : '') + this.formatMoney(total)
            : this.emptyText;
          this.totals.forEach((el) => (el.textContent = text));
        }

        this.addButtons.forEach((button) => (button.disabled = selected.length === 0));
      }

      formatMoney(cents) {
        const placeholder = /\{\{\s*(\w+)\s*\}\}/;
        const match = this.format.match(placeholder);
        const key = match ? match[1] : 'amount';

        const fmt = (decimals, thousands = ',', decimal = '.') => {
          const places = this.round ? 0 : decimals;
          const [whole, fraction] = (cents / 100).toFixed(places).split('.');
          return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
        };

        const values = {
          amount: () => fmt(2),
          amount_no_decimals: () => fmt(0),
          amount_with_comma_separator: () => fmt(2, '.', ','),
          amount_no_decimals_with_comma_separator: () => fmt(0, '.', ','),
          amount_with_space_separator: () => fmt(2, ' ', ','),
          amount_no_decimals_with_space_separator: () => fmt(0, ' '),
          amount_with_apostrophe_separator: () => fmt(2, "'", '.'),
        };

        const value = (values[key] || values.amount)();
        return match ? this.format.replace(placeholder, value) : value;
      }

      async addToCart() {
        const items = this.selectedCards.map((card) => ({ id: this.getVariant(card).id, quantity: 1 }));
        if (!items.length) return;

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.setLoading(true);
        this.setStatus('');

        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong.');

          // Hook for theme cart drawers / counters
          document.dispatchEvent(new CustomEvent('champions-setup:added', { bubbles: true, detail: data }));

          if (this.dataset.afterAdd === 'cart') {
            window.location.href = root + 'cart';
            return;
          }

          // Read the real cart back, then refresh the theme's cart drawer and count
          const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .catch(() => null);
          await this.refreshCartUI();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cart }));

          const opened = this.dataset.afterAdd === 'drawer' && this.openCartDrawer();
          if (!opened) {
            const count = cart ? cart.item_count : null;
            this.setStatus(
              count == null
                ? 'Added to your cart.'
                : 'Added to your cart. You now have ' + count + (count === 1 ? ' item' : ' items') + ' in your cart.'
            );
          }
        } catch (error) {
          this.setStatus(error.message, true);
        } finally {
          this.setLoading(false);
        }
      }

      // Re-renders the theme's cart drawer and cart count using the Section Rendering API
      async refreshCartUI() {
        const selector = [
          'cart-drawer',
          'cart-notification',
          'cart-count',
          '#CartDrawer',
          '#cart-drawer',
          '.cart-drawer',
          '#cart-icon-bubble',
          '.cart-count-bubble',
          '.cart-count',
          '[data-cart-count]',
        ].join(',');

        const topLevel = (scope) =>
          Array.from(scope.querySelectorAll(selector)).filter(
            (el) => !this.contains(el) && !(el.parentElement && el.parentElement.closest(selector))
          );

        const sections = new Map();
        topLevel(document).forEach((el) => {
          const section = el.closest('.shopify-section');
          if (section && section.id) sections.set(section.id.replace('shopify-section-', ''), section);
        });

        const ids = Array.from(sections.keys()).slice(0, 5);
        if (!ids.length) return;

        try {
          const response = await fetch(window.location.pathname + '?sections=' + ids.map(encodeURIComponent).join(','));
          if (!response.ok) return;
          const html = await response.json();

          ids.forEach((id) => {
            if (!html[id]) return;
            const fresh = new DOMParser().parseFromString(html[id], 'text/html');
            const oldEls = topLevel(sections.get(id));
            const newEls = topLevel(fresh);
            if (oldEls.length !== newEls.length) return;
            oldEls.forEach((el, i) => el.replaceWith(document.importNode(newEls[i], true)));
          });
        } catch (error) {
          // Leave the theme UI as it is; the cart itself is already updated
        }
      }

      openCartDrawer() {
        const drawer = document.querySelector('cart-drawer, #CartDrawer, #cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          return true;
        }
        return false;
      }

      setLoading(loading) {
        this.addButtons.forEach((button) => {
          button.classList.toggle('is-loading', loading);
          button.setAttribute('aria-busy', loading);
        });
      }

      setStatus(message, isError = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.classList.toggle('is-error', isError);
      }
    }

    customElements.define('champions-setup', ChampionsSetup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-articles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-articles')) {
    class FeaturedArticles extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-filter-button]'));
        this.items = Array.from(this.querySelectorAll('[data-filter-item]'));
        this.status = this.querySelector('[data-filter-status]');

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.filter(button));
        });

        this.querySelectorAll('[data-video-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', () => this.playVideo(trigger));
        });
      }

      filter(button) {
        const value = button.dataset.filterButton;
        let count = 0;

        this.buttons.forEach((b) => b.setAttribute('aria-pressed', b === button ? 'true' : 'false'));

        this.items.forEach((item) => {
          const match = value === 'all' || item.dataset.filterItem === value;
          item.hidden = !match;
          item.classList.remove('is-revealed');
          if (match) {
            count++;
            void item.offsetWidth; // restart the reveal animation
            item.classList.add('is-revealed');
          }
        });

        if (this.status) {
          this.status.textContent = count + (count === 1 ? ' item' : ' items') + ' shown';
        }
      }

      playVideo(trigger) {
        const { videoType, videoId, videoTitle } = trigger.dataset;
        if (!videoId) return;

        const src =
          videoType === 'vimeo'
            ? 'https://player.vimeo.com/video/' + videoId + '?autoplay=1'
            : 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0&playsinline=1';

        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = videoTitle || 'Video';
        iframe.className = 'article-card__iframe';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;

        trigger.replaceWith(iframe);
      }
    }

    customElements.define('featured-articles', FeaturedArticles);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-nav')) {
    class StickyNav extends HTMLElement {
      constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.ticking = false;
        this.activeLink = null;
      }

      connectedCallback() {
        this.wrapper = this.closest('.shopify-section') || this;
        this.list = this.querySelector('.sticky-nav__list');
        this.links = Array.from(this.querySelectorAll('[data-sticky-nav-link]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.links.forEach((link) => link.addEventListener('click', this.handleClick));
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll);

        this.update();

        if (window.location.hash) {
          const link = this.links.find((l) => '#' + l.dataset.target === window.location.hash);
          if (link) window.addEventListener('load', () => this.scrollToTarget(link.dataset.target, false), { once: true });
        }
      }

      disconnectedCallback() {
        this.links.forEach((link) => link.removeEventListener('click', this.handleClick));
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
      }

      get items() {
        // Looked up live so sections added in the theme editor are picked up
        return this.links
          .map((link) => ({ link, target: document.getElementById(link.dataset.target) }))
          .filter((item) => item.target);
      }

      getOffset() {
        const stickyTop = parseFloat(getComputedStyle(this.wrapper).top) || 0;
        return stickyTop + this.offsetHeight;
      }

      handleClick(event) {
        const id = event.currentTarget.dataset.target;
        if (!document.getElementById(id)) return;
        event.preventDefault();
        this.scrollToTarget(id, !this.reduceMotion);
        history.replaceState(null, '', '#' + id);
      }

      scrollToTarget(id, smooth) {
        const target = document.getElementById(id);
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - this.getOffset() + 1;
        window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
      }

      handleScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      update() {
        const items = this.items;
        const offset = this.getOffset() + 2;
        const scrollY = window.scrollY;
        const viewport = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;

        // Stuck state
        const stickyTop = parseFloat(getComputedStyle(this.wrapper).top) || 0;
        const stuck = scrollY > 0 && this.wrapper.getBoundingClientRect().top <= stickyTop + 0.5;
        this.classList.toggle('is-stuck', stuck);

        // Active link
        let active = null;
        items.forEach((item) => {
          if (item.target.getBoundingClientRect().top - offset <= 0) active = item;
        });
        if (items.length && viewport + scrollY >= docHeight - 2) active = items[items.length - 1];
        this.setActive(active ? active.link : null);

        // Progress
        let progress = 0;
        if (this.dataset.progress === 'sections' && items.length) {
          const first = items[0].target;
          const last = items[items.length - 1].target;
          const start = first.getBoundingClientRect().top + scrollY - offset;
          const end = last.getBoundingClientRect().bottom + scrollY - viewport;
          progress = (scrollY - start) / Math.max(end - start, 1);
        } else {
          progress = scrollY / Math.max(docHeight - viewport, 1);
        }
        progress = Math.min(Math.max(progress, 0), 1);
        this.style.setProperty('--sn-progress', progress.toFixed(4));
      }

      setActive(link) {
        if (link === this.activeLink) return;
        this.links.forEach((l) => l.removeAttribute('aria-current'));
        this.activeLink = link;
        if (!link) return;
        link.setAttribute('aria-current', 'true');

        // Keep the active link visible when the list scrolls horizontally on mobile
        if (this.list && this.list.scrollWidth > this.list.clientWidth) {
          const item = link.parentElement;
          const left = item.offsetLeft - (this.list.clientWidth - item.offsetWidth) / 2;
          this.list.scrollTo({ left, behavior: this.reduceMotion ? 'auto' : 'smooth' });
        }
      }
    }

    customElements.define('sticky-nav', StickyNav);
  }

  } catch(e) { console.error(e); }
})();
})();
